// Abolee: quick-add and pack-upgrade buttons for upsell nudges.
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__abUpsell) {
  window.__abUpsell = true;

  const routes = (window.Theme && window.Theme.routes) || {};
  const addUrl = routes.cart_add_url || '/cart/add.js';
  const changeUrl = (routes.cart_change_url || '/cart/change') + '.js';
  const cartUrl = (routes.cart_url || '/cart') + '.js';

  const post = async (url, body) => {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const json = await res.json();
    if (!res.ok || json.status) throw new Error(json.description || json.message || 'Cart update failed');
    return json;
  };

  const run = async (el, lines, work) => {
    let resolve, reject;
    const promise = new Promise((a, b) => { resolve = a; reject = b; });
    promise.catch(() => {});
    el.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'cart', lines, promise }));
    try {
      await work();
      const cart = await (await fetch(cartUrl, { headers: { Accept: 'application/json' } })).json();
      resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'ab-upsell', didError: false },
      });
    } catch (err) {
      reject(err);
      throw err;
    }
  };

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-ab-add], [data-ab-upgrade]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    btn.disabled = true;
    const label = btn.innerHTML;
    try {
      if (btn.dataset.abAdd) {
        const id = btn.dataset.abAdd;
        await run(btn, [{ merchandiseId: id, quantity: 1 }], () => post(addUrl, { items: [{ id: Number(id), quantity: 1 }] }));
      } else {
        const id = btn.dataset.variant;
        const qty = Number(btn.dataset.qty || 1);
        await run(btn, [{ merchandiseId: id, quantity: qty }], async () => {
          await post(changeUrl, { id: btn.dataset.abUpgrade, quantity: 0 });
          await post(addUrl, { items: [{ id: Number(id), quantity: qty }] });
        });
      }
      btn.textContent = 'Added ✓';
      if (/\/cart\/?$/.test(location.pathname)) location.reload();
    } catch (err) {
      console.warn('[ab-upsell]', err);
      btn.innerHTML = label;
      btn.disabled = false;
    }
  });
}
